import React from 'react';
import './LoadingSkeleton.css';

export const SkeletonBar = ({ width = '75%' }) => (
  <div className="list-skeleton-bar" style={{ width }} aria-hidden="true" />
);

export const SkeletonRows = ({ columns, rows = 8 }) => (
  <>
    {Array.from({ length: rows }, (_, row) => (
      <tr key={row} className="list-skeleton-row">
        {Array.from({ length: columns }, (_, column) => (
          <td key={column}>
            {row === 0 && column === 0 && <span className="list-skeleton-label" role="status">Loading...</span>}
            <SkeletonBar width={column === 0 ? '65%' : '80%'} />
          </td>
        ))}
      </tr>
    ))}
  </>
);

export const SkeletonTable = ({ headings, title }) => (
  <div className="list-skeleton-table-wrap" aria-busy="true">
    {title && <div className="list-skeleton-heading"><h2>{title}</h2><SkeletonBar width="min(320px, 80%)" /></div>}
    <table className="list-skeleton-table">
      <thead><tr>{headings.map(heading => <th key={heading}>{heading}</th>)}</tr></thead>
      <tbody><SkeletonRows columns={headings.length} /></tbody>
    </table>
  </div>
);

export const SkeletonCards = ({ className, itemClassName, rows = 6, label = 'Loading...' }) => (
  <div className={className} aria-busy="true">
    <span className="list-skeleton-label" role="status">{label}</span>
    {Array.from({ length: rows }, (_, index) => (
      <div className={`${itemClassName} list-skeleton-card`} key={index} aria-hidden="true">
        <SkeletonBar width="30%" />
        <SkeletonBar width="65%" />
        <SkeletonBar width="85%" />
      </div>
    ))}
  </div>
);
